module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_2.afc0336b.png";